import React, { Component } from 'react'
import { line, curveCardinal } from 'd3'

const lineFunction = line()
    .x(d => d.x)
    .y(d => d.y)
    .curve(curveCardinal)

const STEP = 7

export default class MapLine extends Component {

    static defaultProps = {
        points: []
    }

    constructor(props) {
        super(props)

        this.state = {
            offset: 0
        }
        this.timer = null
        this.path = document.createElementNS("http://www.w3.org/2000/svg", "path")
    }

    componentDidMount() {
        this.timer = setInterval(::this.updateOffset, 100)
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    updateOffset() {
        this.setState({
            offset: (this.state.offset + 1) % (STEP * 5)
        })
    }

    getArrows(pathStr, offset) {
        if (!pathStr) {
            return []
        }

        this.path.setAttribute('d', pathStr)

        const length = this.path.getTotalLength()
        const steps = Math.floor(length / STEP)

        const arrows = []

        for (let i = 0; i < steps; i++) {
            if (i % 5 === 0 && i + 1 < steps) {
                const point = this.path.getPointAtLength(i * STEP + offset)
                const p1 = this.path.getPointAtLength((i - 1) * STEP + offset)
                const p2 = this.path.getPointAtLength((i + 1) * STEP + offset)
                arrows.push({
                    x: point.x,
                    y: point.y,
                    index: 1,
                    rotation: Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI + 90
                })
            }
        }

        return arrows
    }

    render() {
        const { points } = this.props
        const pathStr = lineFunction(points)
        const arrows = this.getArrows(pathStr, this.state.offset)

        return (
            <g>
                <path d={pathStr} key="line-background" stroke="#FFF2F4" strokeWidth="10" strokeLinecap="round" fill="transparent" />
                <path d={pathStr} key="line" stroke="#DB2036" strokeWidth="2" strokeLinecap="round" fill="transparent" strokeDasharray="0, 6" />
                {arrows.map((arrow, index) => (
                    <use
                        xlinkHref="#lineArrow"
                        key={`arrow-${index}`}
                        x="0"
                        y="0"
                        width="10"
                        height="10"
                        transform={`translate(${arrow.x - 5},${arrow.y - 5}) rotate(${arrow.rotation} 5,5)`}
                    />
                ))}

                {/* {[points[0], points[points.length - 1]].map((point, index) => <circle cx={point.x} cy={point.y} key={index} r="4" fill="#DB2036" />)} */ }
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./components/MapLine.js